import React from "react";
import "./../../UaeAttestation/UaeReq/UaeReq.css";

const VietnamReqMain = () => {
  return (
    <div className="uaeReqMainContainer">
      <div className="uaeReqMainContent">
        <h3>Requirement of Vietnam Attestation:</h3>
        <p>
          Certificate attestation for Vietnam visa is required for several
          reasons such as student visa, residence visa, work visa, or business
          aspects. It is a part of the evidence that exhibits that you are a
          genuine person or company. It proves that your documents are genuine &
          can be allowed in the country.
        </p>
      </div>
      <div className="uaeReqMainContent">
        <h3>Total time-span to get Vietnam Certificate Attestation:</h3>
        <p>
          The time span needed for Certificate attestation for Vietnam depends
          upon a variety of reasons like which country you need the
          authentication for, or the types of documents, or the state you need
          it from. It will take around 15 days to a month to accomplish.
        </p>
      </div>
    </div>
  );
};

export default VietnamReqMain;
